import TableOne from "./components/TableOne"

interface ErgonomicsProps {
    highlighting: boolean;
    dateRange: [Date | undefined, Date | undefined];
    currentArea: string;
    currentSubArea: string | null;
    filterSmallValues:boolean
  }

function Ergonomics({highlighting,dateRange,currentArea,currentSubArea,filterSmallValues}:ErgonomicsProps) {
  return (
    <div>
        <TableOne
         highlighting={highlighting}
         dateRange={dateRange}
         currentArea={currentArea}
         currentSubArea={currentSubArea}
         filterSmallValues={filterSmallValues}
        />
    </div>
  )
}

export default Ergonomics